import React from 'react';
import { Construction, Clock, Wrench } from 'lucide-react';

const UnderConstruction = ({
    title = "Under Construction",
    message = "We're working hard to bring you something amazing. Please check back soon!",
    showAnimation = true
}) => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-50 flex items-center justify-center p-4">
            <div className="max-w-2xl mx-auto text-center">
                {/* Animated Construction Icon */}
                <div className="mb-8 relative">
                    <div className={`inline-block ${showAnimation ? 'animate-bounce' : ''}`}>
                        <Construction className="w-24 h-24 text-orange-500 mx-auto" />
                    </div>
                    {/* Decorative Tools */}
                    {/* <div className="absolute -top-4 -right-4">
                        <Wrench className={`w-8 h-8 text-gray-400 ${showAnimation ? 'animate-pulse' : ''}`} />
                    </div> */}
                </div>

                {/* Main Content */}
                <div className="space-y-6">
                    <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-4">
                        {title}
                    </h1>
                    {/*           
          <div className="bg-white/70 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-orange-100">
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              {message}
            </p>
          </div> */}

                    {/* Progress Indicator */}
                    <div className="bg-white/50 rounded-full p-1 max-w-md mx-auto">
                        <div className="bg-gradient-to-r from-orange-400 to-yellow-400 h-3 rounded-full relative overflow-hidden">
                            <div className={`absolute inset-0 bg-white/30 ${showAnimation ? 'animate-pulse' : ''}`}></div>
                        </div>
                    </div>

                    {/* Status Text */}
                    <div className="flex items-center justify-center space-x-2 text-orange-600">
                        <Clock className="w-5 h-5" />
                        <span className="font-medium">Currently in development</span>
                    </div>

                    {/* Contact Info */}
                    {/* <div className="mt-8 p-4 bg-white/40 rounded-lg border border-orange-100">
            <p className="text-sm text-gray-500">
              Have questions? Contact us at{' '}
              <a href="mailto:info@example.com" className="text-orange-600 hover:text-orange-700 font-medium">
                info@example.com
              </a>
            </p>
          </div> */}
                </div>
            </div>
        </div>
    );
};

export default UnderConstruction;